import type { Directive } from 'vue'
import { useAppUserStore } from '@/modules/app-user/stores/app-user.store.ts'

// v-permission directive
export const permissionDirective: Directive = {
  mounted(el, binding) {
    const userStore = useAppUserStore()
    const { value } = binding

    if (typeof value === 'string') {
      // Single permission: v-permission="'user.create'"
      if (!userStore.hasPermission(value)) {
        el.style.display = 'none'
      }
    } else if (Array.isArray(value)) {
      // Multiple permissions: v-permission="['user.create', 'user.edit']"
      if (!userStore.hasAnyPermission(value)) {
        el.style.display = 'none'
      }
    } else if (typeof value === 'object') {
      // Advanced: v-permission="{ permissions: ['user.create'], requireAll: true }"
      const permissions = value.permissions || []
      const requireAll = value.requireAll || false

      const hasAccess = requireAll
        ? userStore.hasAllPermissions(permissions)
        : userStore.hasAnyPermission(permissions)

      if (!hasAccess) {
        el.style.display = 'none'
      }
    }
  },
}
